import { Router } from '@angular/router';
import { Injectable } from '@angular/core';


import { Observable } from 'rxjs';

@Injectable()
export class AuthService {
  token: string;
  redirectUrl:any;

  constructor(private router: Router) {}

  // constructor(public _firebaseAuth: AngularFireAuth, public router: Router) {
  //   this.user = _firebaseAuth.authState;
  //   this.user.subscribe(
  //     (user) => {
  //       if (user) {
  //         this.userDetails = user;
  //       }
  //       else {
  //         this.userDetails = null;
  //       }
  //     }
  //   );

  // }

  signupUser(email: string, password: string) {
    //your code for signing up the new user
  }
  
  loggedIn() {
   
    if (sessionStorage.getItem('token') == 'undefined' || sessionStorage.getItem('token') === '') {
      return !!sessionStorage.getItem('0')
    }
    return !!sessionStorage.getItem('token')
  }

  signinUser(email: string, password: string) {
    //your code for checking credentials and getting tokens for for signing in user
    // return this._firebaseAuth.signInWithEmailAndPassword(email, password)

    //uncomment above firebase auth code and remove this temp code
    return new Promise(function(resolve, reject) {
      setTimeout(function() {
        resolve(true);
      }, 1000);
    });

  }

  logout() {
   
  }


  isAuthenticated() {
    if( sessionStorage.getItem('token')){
      return true;
    }else{
      this.router.navigateByUrl('/Select');
      return false;
    }
    // here you can check if user is authenticated or not through his token
  }
}
